import axios from "axios";

function upgradeToHttpsIfNeeded(url) {
  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    typeof url === "string" &&
    url.startsWith("http://")
  ) {
    return `https://${url.slice("http://".length)}`;
  }
  return url;
}

function isNgrokUrl(url) {
  return typeof url === "string" && /ngrok/i.test(url);
}

/** Resolve final URL before Axios merges baseURL + path (covers all request shapes). */
function getAbsoluteRequestUrl(config) {
  const url = config.url;
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const base = (config.baseURL || "").replace(/\/?$/, "");
  if (!base) return url;
  try {
    const path = url.startsWith("/") ? url : `/${url}`;
    return new URL(path, `${base}/`).href;
  } catch {
    return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
  }
}

function writeAbsoluteUrl(config, absolute) {
  config.baseURL = "";
  config.url = absolute;
}

axios.interceptors.request.use((config) => {
  const full = getAbsoluteRequestUrl(config);
  if (!full || !/^https?:\/\//i.test(full)) {
    return config;
  }
  const upgraded = upgradeToHttpsIfNeeded(full);
  writeAbsoluteUrl(config, upgraded);
  if (isNgrokUrl(upgraded)) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === "function") {
      config.headers.set("ngrok-skip-browser-warning", "true");
    } else {
      config.headers["ngrok-skip-browser-warning"] = "true";
    }
  }
  return config;
});

if (typeof window !== "undefined" && typeof window.fetch === "function") {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const urlString =
      typeof input === "string"
        ? input
        : input instanceof Request
          ? input.url
          : "";
    const finalUrl = upgradeToHttpsIfNeeded(urlString);
    const baseHeaders = new Headers(
      init?.headers ?? (input instanceof Request ? input.headers : undefined)
    );
    if (isNgrokUrl(finalUrl || urlString)) {
      baseHeaders.set("ngrok-skip-browser-warning", "true");
    }
    const nextInit = { ...init, headers: baseHeaders };

    if (typeof input === "string") {
      return nativeFetch(finalUrl, nextInit);
    }
    if (input instanceof Request) {
      if (finalUrl !== input.url) {
        return nativeFetch(new Request(finalUrl, input), nextInit);
      }
      return nativeFetch(new Request(input, { headers: baseHeaders }), nextInit);
    }
    return nativeFetch(input, nextInit);
  };
}
